(function () {
  if (window.__AG_PB_MT_LIST_INIT__) return;
  window.__AG_PB_MT_LIST_INIT__ = true;

  var DESKTOP_MIN = 741;

  function isDesktop() {
    return window.matchMedia('(min-width: ' + DESKTOP_MIN + 'px)').matches;
  }

  function getItems(list) {
    return Array.prototype.slice.call(list.querySelectorAll('.ag-pb-media-text__list-item'));
  }

  function shouldEqualize(list) {
    var mode = list.getAttribute('data-equal-height') || 'none';
    if (mode === 'none' || mode === '') return false;
    if (mode === 'both') return true;
    if (mode === 'desktop') return isDesktop();
    if (mode === 'mobile') return !isDesktop();
    return false;
  }

  function equalizeList(list) {
    var items = getItems(list);
    items.forEach(function (el) {
      el.style.minHeight = '';
    });

    if (!shouldEqualize(list) || items.length < 2) return;

    var max = 0;
    items.forEach(function (el) {
      max = Math.max(max, el.getBoundingClientRect().height);
    });

    if (max <= 0) return;

    var height = Math.ceil(max) + 'px';
    items.forEach(function (el) {
      el.style.minHeight = height;
    });
  }

  function equalizeAll() {
    document.querySelectorAll('.js-ag-pb-media-text-list').forEach(equalizeList);
  }

  var resizeTimer;
  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(equalizeAll, 150);
  }

  function init() {
    equalizeAll();
    window.addEventListener('resize', onResize);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(equalizeAll).catch(function () {});
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', equalizeAll);
  document.addEventListener('shopify:block:select', equalizeAll);
  document.addEventListener('shopify:section:reorder', equalizeAll);
})();
